<div [formGroup]="tad_applicant_moved_in_form" id="movedinAddress{{incomingApplicantSequence}}{{iterator}}">
  @if (!(iterator !== 0 && haslived3year)) {
    <div>
      <div class="row" id="address{{incomingApplicantSequence}}{{iterator}}">
        <div class="col col-md-6">
          <div class='form-group'>
            @if (iterator === 0) {
              <label>Address</label>
            }
            @if (iterator !== 0) {
              <label>Previous address</label>
            }
            @if (iterator > 1) {
              <label>{{iterator}}</label>
            }
            <app-address [incomingAddress]="address" [index]="index" (outgoingAddress)="_handleIncomingAddress($event)" [addressLookUp]="tad_applicant_moved_in_form.controls.addresslookup" (form_out)="_handleIncomingForm($event)"></app-address>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-md-6">
          @if (iterator === 0) {
            <fieldset class="form-group">
              <legend>Have you lived at this address for 3 years or more?</legend>
              <div class="d-flex">
                <div class="w-40 mr-1">
                  <div class="c-radio--separated">
                    <span class="c-radio-button">
                  <input type="radio" name="tad_lived_three_year" [checked]="(tad_lived_three_year.value == true || tad_lived_three_year.value == 'true') && (tad_lived_three_year.dirty || tad_lived_three_year.touched
            || _currentState == 4) && iterator == 0" formControlName="tad_lived_three_year"
                        id="tad_lived_three_year_yes{{incomingApplicantSequence}}" (click)="onChange(true)" value="true">
                        <label class="c-radio-button__label" for="tad_lived_three_year_yes{{incomingApplicantSequence}}">
                          <span class="c-radio-button__faux">Yes</span>
                          <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13">
                            <path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
                          </svg>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div class="w-40">
                    <div class="c-radio--separated">
                      <span class="c-radio-button">
                  <input type="radio" name="tad_lived_three_year" [checked]="(tad_lived_three_year.value == false || tad_lived_three_year.value == 'false') && (tad_lived_three_year.dirty || tad_lived_three_year.touched
             || _currentState == 4) && iterator == 0" formControlName="tad_lived_three_year"
                          id="tad_lived_three_year_no{{incomingApplicantSequence}}" (click)="onChange(false)" value="false">
                          <label class="c-radio-button__label" for="tad_lived_three_year_no{{incomingApplicantSequence}}">
                            <span class="c-radio-button__faux">No</span>
                            <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13">
                              <path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
                            </svg>
                          </label>
                        </span>
                      </div>
                    </div>
                    <div class="w-20 text-right">
                      <together-auction-dip-tooltip [placement]="'top'" [class]="'tooltip-sm-down'" [title]="'If you\'ve lived at your current address for less than 3 years, we need your previous address details to complete a soft credit search.'" [placement]="'top'"></together-auction-dip-tooltip>
                    </div>
                  </div>
                  @if (iterator === 0) {
                    <div>
                      <together-auction-dip-validate-fields [displayError]="hasLived3yearSelected && _currentState != 4" errorMsg="Please choose Yes or No."></together-auction-dip-validate-fields>
                    </div>
                  }
                </fieldset>
              }
            </div>
          </div>
          @if (_haslived3year === false || iterator > 0 || (has_multiple_addresses && _currentState == 4)) {
            <fieldset class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_moved_in_date_month')">
              <legend>When did you move in?</legend>
              <div class="row">
                <div class="col col-md-6">
                  <div class="d-flex">
                    <div class="w-30 mr-1">
                      <label for="tad_moved_in_date_month" class="visually-hidden">Month (MM)</label>
                      <input type="number" class="form-control" [ngClass]="setDynamicClasses('tad_moved_in_date_month')" formControlName="tad_moved_in_date_month" placeholder="MM" min="1" max="31" maxLength="2">
                    </div>
                    <div class="w-30">
                      <label for="tad_moved_in_date_year" class="visually-hidden">Year (YYYY)</label>
                      <input type="number" class="form-control" [ngClass]="setDynamicClasses('tad_moved_in_date_year')" formControlName="tad_moved_in_date_year" placeholder="YYYY" min="1"  maxLength="4">
                    </div>
                  </div>
                </div>
              </div>
      <!-- <together-auction-dip-validate-fields [displayError]="tad_applicant_moved_in_form.
      get('tad_moved_in_date_month').touched && tad_applicant_moved_in_form.
      get('tad_moved_in_date_month').errors?.required" errorMsg="Please enter month."></together-auction-dip-validate-fields> -->
      <together-auction-dip-validate-fields [displayError]="tad_applicant_moved_in_form.
            get('tad_moved_in_date_year').touched && tad_applicant_moved_in_form.
            get('tad_moved_in_date_year').errors?.required &&
            tad_applicant_moved_in_form.
            get('tad_moved_in_date_month').touched &&
            tad_applicant_moved_in_form.
            get('tad_moved_in_date_month').errors?.required" errorMsg="We need this date."></together-auction-dip-validate-fields>
            <together-auction-dip-validate-fields [displayError]="tad_applicant_moved_in_form.hasError('dateInFuture')" errorMsg="Date moved in must be past date"></together-auction-dip-validate-fields>
      <together-auction-dip-validate-fields [displayError]="(tad_applicant_moved_in_form.get('tad_moved_in_date_year').touched &&
             (tad_applicant_moved_in_form.get('tad_moved_in_date_year').errors?.min)) || (tad_applicant_moved_in_form.get('tad_moved_in_date_month').touched &&
             (tad_applicant_moved_in_form.get('tad_moved_in_date_month').errors?.max || tad_applicant_moved_in_form.get('tad_moved_in_date_month').errors?.min))"
            errorMsg="Please enter a valid date."></together-auction-dip-validate-fields>
      <together-auction-dip-validate-fields [displayError]="(tad_applicant_moved_in_form.
            get('tad_moved_in_date_year').touched && tad_applicant_moved_in_form.
            get('tad_moved_in_date_year').errors?.max)" errorMsg="Date moved in must be past date"></together-auction-dip-validate-fields>
          </fieldset>
        }
      </div>
    }
  </div>
